module.exports = __webpack_public_path__ + "img/join.519dd39b.png";